import { supabase } from "../../supabaseClient";

export async function fetchOooByHotelIds(hotelIds = []) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) throw new Error("User not logged in");

  const token = session.access_token;
  const results = {};

  for (let hotelId of hotelIds) {
    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/ohip-ooo?hotelId=${hotelId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`OHIP fetch failed for ${hotelId}: ${text}`);
    }

    const json = await res.json();
    results[hotelId] = json.housekeepingRooms?.room || [];
  }

  return results;
}
